import {defineNuxtPlugin} from "nuxt/app";

export default defineNuxtPlugin(async (nuxtApp: any) => {

    nuxtApp.hook('app:created', async () => {


		//const { $globalSettings } = nuxtApp
		//console.log("Global hooks: ",$globalSettings)

    });

    nuxtApp.hook('page:start', async () => {
        if (process.client) {
        }
    })
})
